import React, { useEffect, useRef, useCallback } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useRouter } from './components';
import { StoreProvider } from './store';
import { ViewPage } from './cms/pages/viewPage/viewPage';
import { EditPage } from './cms/pages/editPage/editPage';
import { TopHeader } from './layout/topHeader/topHeader2';
// import { Footer } from './layout/footer/footer';
import { BottomDock } from './layout/bottomDock/bottomDock';
// import { BlogView } from './site/blog/blogView';
import { AppVersionPage } from './components';
import { MediaQueryStatus } from './components';
import { CommonVideoPopup } from "./layout/popup/commonVideoPopup";
import { HelmetProvider } from 'react-helmet-async';
//import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { AppRouteChanged } from './AppRouteChanged';
import AOS from 'aos';

//For ECM
import { ProductView } from './site/ecm/product/productView';
import { OrderDetails } from './site/ecm/orderDetails/orderDetails';
import { LiveFeedCheckout } from './site/ecm/liveFeedCheckout/liveFeedCheckout';
import { DartfishCheckout } from './site/ecm/dartfishCheckout/dartfishCheckout';
import { WatchPage } from './site/ecm/watch/WatchPage';
import { OrderHistoryPage } from './site/ecm/orderHistory/OrderHistoryPage';
import { MemberDashboard } from './site/ecm/memberDashboard/MemberDashboard';
import env from './env';
import { useStore } from './store';

// For Auth (ABNA-style login system)
import { ProvideAuth } from './auth';
import { Login, Signup, ForgotPassword, ResetPassword } from './auth';
import { RequireAuth } from './components';
import { PwaInstallPrompt } from './components';

import NotificationBar from './components/notification/NotificationBar';
import NotificationPermission from './components/notification/NotificationPermission';
import { setupForegroundMessageHandler, listenForPushNotificationClickMessages } from './push/firebaseUtils';

function AppLayout(props) {
  const { pathname } = useRouter();
  const { state, dispatch } = useStore();
  const pushEnabled = process.env.NODE_ENV === 'production';

  const handlePushTokenReceived = useCallback((token) => {
    if (token) {
      console.log('[push] FCM token registered');
    }
  }, []);

  // Ensure the menu is always populated, even when landing directly on a
  // non-CMS route (e.g. /members-area after returning from an external stream).
  // ViewPage normally sets the menu, but it doesn't run on hardcoded routes.
  useEffect(() => {
    if (state.menu) return;
    fetch(env.apiBase + '/api/cms/GetPublishedPage?path=/')
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (data && data.menu) {
          dispatch({ type: 'SET_MENU', payload: data.menu });
        }
      })
      .catch(() => {});
  }, [state.menu, dispatch]);

  //For ECM
  const storeContext = useRef(useStore());

  //const [scrolled, setScrolled] = useState(false)
  //const path = usePath();
  //const routeResult = useRoutes(routes);

  // const parallax = useParallax();
  // //console.log(path, routeResult);
  // const routeChanged = (path) => {
  //   //console.log(path);
  //   parallax.reset();
  // }

  // useScrollPosition(({ prevPos, currPos }) => {
  //   //console.log(currPos.x)
  //   //console.log(currPos.y);
  //   if (currPos.y > 90) {
  //     document.querySelector('body').classList.add('scrolled')
  //   } else {
  //     document.querySelector('body').classList.remove('scrolled')
  //   }
  //   //setScrolled(currPos.y > 90)
  // }, [], null, true)

  //const pageChanged = useCallback(path => routeChanged(path), [])
  //useLocationChange((path) => { routeChanged(path, history)})
  //useLocationChange(path => routeChanged(path))

  //const pathFiltered = (pathname || '').toLocaleLowerCase();
  let specialClassName = '';
  //  if (pathFiltered.indexOf('/digital-sensor') >= 0) specialClassName = 'digital-sensor-page';
  //  else if (pathFiltered === '/brilliance') specialClassName = 'brilliance-page';

  useEffect(() => {
    AOS.init({
      duration: 1200
      //delay:400,
      //once:true
    });

    // For ECM
    fetch(env.apiBase + "/api/cart/getcart/" + env.getDevCartId())
      .then(res => res.json())
      .then(res => {
          const data = res;
          if(data){
            storeContext.current.dispatch({type:'SET_STATE', payload : {cartInfo : data.cartInfo.totalQuantity === 0 ? 0 : (data.cartInfo.totalQuantity)-1}});
          }
      })
      .catch(error =>{
        storeContext.current.dispatch({type:'SET_STATE', payload : {cartInfo : 0}});
    });

  }, []);

  useEffect(() => {
    if (!pushEnabled) return undefined;
    const unsubForeground = setupForegroundMessageHandler();
    const unsubSwMessage = listenForPushNotificationClickMessages();
    return () => {
      if (typeof unsubForeground === 'function') unsubForeground();
      if (typeof unsubSwMessage === 'function') unsubSwMessage();
    };
  }, [pushEnabled]);

  return (
    <div className={`body-content ${pathname === '/' ? 'homepage' : 'subpage'} ${specialClassName}`}>
      <AppRouteChanged />
      {pushEnabled && (
        <>
          <NotificationBar onTokenReceived={handlePushTokenReceived} />
          <NotificationPermission onTokenReceived={handlePushTokenReceived} />
        </>
      )}
      <TopHeader></TopHeader>
      <div className="main-content">
        <div className="app-content">
          <Switch>
            <Route path="/ver" children={<AppVersionPage />} />
            <Route path="/cms/page/render/:id" children={<EditPage />} />
            <Route path="/login" children={<Login />} />
            <Route path="/sign-up" children={<Signup />} />
            <Route path="/forgot-password" children={<ForgotPassword />} />
            <Route path="/auth/reset-password" children={<ResetPassword />} />

            <RequireAuth path="/members-area/my-account" component={MemberDashboard} redirectTo="/login" />
            <RequireAuth path="/members-area" component={MemberDashboard} redirectTo="/login" />
            <RequireAuth path="/member-area" component={MemberDashboard} redirectTo="/login" />

            <Route path="/admin">
              <Redirect to="/admin" />
            </Route>

            {/* For ECM  */}
            <Route path="/order-thankyou" children = {<OrderDetails />}/>
            <Route path="/checkout/live-feed" children={<LiveFeedCheckout />} />
            <Route path="/checkout/dartfish" children={<DartfishCheckout />} />
            <Route path="/watch" children={<WatchPage />} />
            <RequireAuth path="/account/orders" component={OrderHistoryPage} redirectTo="/login" />
            <Route path="/product/:slug" children = {<ProductView />}/>

            <Route path="/">
              <ViewPage />
            </Route>
          </Switch>
        </div>
        {/* <app-common-bottom-partial></app-common-bottom-partial> */}
      </div>
      {/* <Footer></Footer> */}
      <BottomDock></BottomDock>
      <MediaQueryStatus />
      <CommonVideoPopup />
      <PwaInstallPrompt />
    </div>
  );
}

function App() {
  return (
    <StoreProvider>
      <Router>
        <ProvideAuth>
          <HelmetProvider>
            <AppLayout />
          </HelmetProvider>
        </ProvideAuth>
      </Router>
    </StoreProvider>
  );
}

export default App;